<template>
  <nav v-if="isOpen" class="header__menu" @click.self="emit('close')">
    <div class="header__menu-inner" :class="{ 'header__menu-inner--open': isOpen }">
      <div class="container">
        <ul class="header__menu-list">
          <li
            v-for="item in items"
            :key="item.linkName"
            class="header__menu-item"
          >
            <router-link
              :to="{ name: item.linkName }"
              class="header__menu-link"
              active-class="header__menu-link--active"
              exact-active-class="header__menu-link--active"
              @click="emit('close')"
            >
              {{ item.title }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
const props = defineProps({
  isOpen: { type: Boolean, required: true },
  items: { type: Array, required: true }
})

const emit = defineEmits(['close'])
</script>